import { j as e } from "../../../_virtual/jsx-runtime.js";
import { useState as c, useEffect as h } from "react";
import g from "../Input.js";
import { Form as a, Checkbox as x, message as n } from "antd";
import _ from "./comps/Success.js";
import { useIsMobile as b } from "../../hook/useIsMobile.js";
import { login as y } from "../../api/auth/index.js";
import o from "localforage";
import { StorageKeyEnum as i } from "../../const/StorageKeyEnum.js";
import { useNavigate as j } from "react-router-dom";
import { AuthContainer as R, AuthTitle as A, AuthButton as N } from "./styles.js";
function q(u) {
  const [s] = a.useForm(), [p, v] = c(!1), [d, f] = c(!1), [E, m] = c(!1), l = b(), M = j();
  h(() => {
    o.removeItem(i.ADMIN_TOKEN), o.removeItem(i.ADMIN_REFRESH_TOKEN), o.removeItem(i.ADMIN_TOKEN_EXPIRE_TIME);
  }, []), h(() => {
    o.getItem(i.ADMIN_REMEMBER_ME).then((t) => {
      t?.email && (f(!0), s.setFieldsValue({ email: t.email }));
    });
  }, []);
  const I = async () => {
    if (await s.validateFields()) {
      m(!0);
      try {
        const t = s.getFieldsValue(), r = await y({ email: t.email, totp_code: t.totp_code });
        if (r.code != 0 || !r.data) {
          n.error(r.message), m(!1);
          return;
        }
        n.success("login success"), d ? o.setItem(i.ADMIN_REMEMBER_ME, {
          email: t.email
        }) : o.removeItem(i.ADMIN_REMEMBER_ME), await u.onSuccess(r.data.user), M("/", { replace: !0 });
      } catch {
        n.error("login failed"), m(!1);
      }
    }
  };
  return p ? /* @__PURE__ */ e.jsx(_, { title: "Login Success", description: "You have successfully logged in to your account." }) : /* @__PURE__ */ e.jsxs(R, { children: [
    /* @__PURE__ */ e.jsx("div", { children: u.logo }),
    /* @__PURE__ */ e.jsx(A, { children: "Welcome to Ocash" }),
    /* @__PURE__ */ e.jsxs(a, { form: s, style: { width: "100%", maxWidth: 392 }, onFinish: I, children: [
      /* @__PURE__ */ e.jsx(a.Item, { name: "email", rules: [{ required: !0, message: "Please input your email!" }, { type: "email", message: "Invalid email" }], children: /* @__PURE__ */ e.jsx(g, { placeholder: "Enter email address", label: "Email", style: { width: l.isMobile ? "100%" : 392 }, autoComplete: "off" }) }),
      /* @__PURE__ */ e.jsx(a.Item, { name: "totp_code", rules: [{ required: !0, message: "Please input your code!" }, { pattern: /^\d{6}(\d{2})?$/, message: "6 or 8 digits required" }], children: /* @__PURE__ */ e.jsx(g, { placeholder: "Enter 6 or 8-digit code", label: "Authenticator Code", maxLength: 8, autoComplete: "one-time-code", style: { width: l.isMobile ? "100%" : 392 } }) }),
      /* @__PURE__ */ e.jsx(x, { checked: d, onChange: (t) => f(t.target.checked), children: "Remember email" }),
      /* @__PURE__ */ e.jsx(N, { htmlType: "submit", type: "primary", loading: E, $isMobile: l.isMobile, children: "Log in" })
    ] })
  ] });
}
export {
  q as default
};
